<div
  class="app-shell"
  [class.app-shell--header-compact]="headerCompact()"
  [class.app-shell--mobile]="isMobile()"
  [class.app-shell--search-open]="mobileSearchOpen()"
>
  <a
    class="app-shell__skip-link"
    href="#main-content"
    (click)="skipToContent($event)"
    [attr.inert]="interfaceBlocked() ? '' : null"
  >{{ 'accessibility.skipToContent' | translate }}</a>

  <app-toast></app-toast>

  <app-header [compact]="headerCompact()" [attr.inert]="interfaceBlocked() ? '' : null"></app-header>

  <app-mobile-nav-drawer></app-mobile-nav-drawer>

  @if (authDialog.loginOpen()) {
    <app-login-modal></app-login-modal>
  }

  <div
    class="app-shell__layout"
    [attr.inert]="interfaceBlocked() ? '' : null"
    [class.app-shell__layout--sports-collapsed]="!sportsbook.sportsMenuExpanded()"
    [class.app-shell__layout--betslip-collapsed]="!sportsbook.betSlipExpanded()"
  >
    <aside class="app-shell__sports" [attr.aria-label]="'sportsMenu.title' | translate">
      <app-sports-menu
        [sports]="sportsbook.sports()"
        [expanded]="sportsbook.sportsMenuExpanded()"
        [loading]="session.matchesLoading()"
        (toggleExpanded)="sportsbook.toggleSportsMenu()"
        (sportToggle)="sportsbook.toggleSport($event)"
      ></app-sports-menu>
    </aside>

    <main #mainContent id="main-content" class="app-shell__content" tabindex="-1">
      @if (session.matchesLoadFailed()) {
        <div class="app-shell__offer-recovery sb-card-shell">
          <p role="status">{{ 'home.loadFailed' | translate }}</p>
          <button type="button" class="sb-button" (click)="retryMatchData()">{{ 'home.retry' | translate }}</button>
        </div>
      }
      <router-outlet></router-outlet>
    </main>

    @if (!isMobile()) {
      <aside class="app-shell__betslip" [attr.aria-label]="'betslip.title' | translate">
        <app-betslip
          [expanded]="sportsbook.betSlipExpanded()"
          [groups]="sportsbook.betSlipGroups()"
          [summary]="sportsbook.betSlipSummary()"
          [submissionState]="sportsbook.betSlipSubmissionState()"
          [maxWinPulseKey]="sportsbook.maxWinPulseKey()"
          (toggleExpanded)="sportsbook.toggleBetSlip()"
          (selectionToggle)="sportsbook.toggleSelection($event)"
          (stakeChange)="sportsbook.updateStake($event)"
          (modeChange)="sportsbook.setBetSlipMode($event)"
          (systemStep)="sportsbook.stepBetSlipSystemX($event)"
          (clearBetSlip)="sportsbook.clearBetSlip()"
          (placeBet)="sportsbook.placeBet()"
        ></app-betslip>
      </aside>
    }
  </div>

  <app-site-footer
    [attr.inert]="interfaceBlocked() ? '' : null"
    [sports]="sportsbook.sports()"
    [loading]="session.matchesLoading()"
    (sportNavigate)="openFooterSport($event)"
  ></app-site-footer>

  @if (isMobile()) {
    <app-mobile-shortcuts
      [attr.inert]="interfaceBlocked() ? '' : null"
      [summary]="sportsbook.betSlipSummary()"
      [maxWinPulseKey]="sportsbook.maxWinPulseKey()"
      [searchEnabled]="mobileSearchEnabled()"
      [searchOpen]="mobileSearchOpen()"
      [searchQuery]="sportsbook.searchQuery()"
      [liveActive]="mobileSearchEnabled() && sportsbook.activeFilter() === 'live'"
      [bonusHint]="sportsbook.betSlipBonusHint()"
      (toggleSearch)="toggleMobileSearch()"
      (closeSearch)="mobileSearchOpen.set(false)"
      (openBetSlip)="openMobileBetSlip()"
      (openLive)="openMobileLive()"
    ></app-mobile-shortcuts>
  }
</div>
